import { useParams } from "react-router-dom";
import { useMutation } from "@apollo/client";
import AutoSizer, { Size } from "react-virtualized-auto-sizer";
import { UPDATE_DETOUR, REMOVE_DETOUR, tokenOptions } from "../../backend/graphql";
import { useAppSelector } from "../../app/hooks";
import { backendURL } from "../../constants";
import MaskEditor from "../widgets/MaskEditor";

// Correct one detour sample's golden outline. The sample id is the route param, and the training
// endpoints serve its clip, enriched map and golden blobs directly, so no extra query is needed.
const DetourEdit = () => {
  const { id } = useParams();
  const token = useAppSelector((state) => state.auth.token);
  const [updateDetour] = useMutation(UPDATE_DETOUR, tokenOptions(token));
  const [removeDetour] = useMutation(REMOVE_DETOUR, tokenOptions(token));

  // The editor opens in its own tab, so each of save/delete/cancel closes it when done.
  const save = (golden: string) =>
    updateDetour({ variables: { id, newGolden: golden } }).then(() => window.close());

  const remove = () => removeDetour({ variables: { id } }).then(() => window.close());

  return (
    <AutoSizer>
      {({ width, height }: Size) => (
        <div style={{ width, height }}>
          <MaskEditor
            size={1024}
            backdrops={[
              { key: "clip", label: "Diamond", src: `${backendURL}/training/detour/${id}/clip` },
              { key: "enriched", label: "Enriched", src: `${backendURL}/training/detour/${id}/enriched` },
            ]}
            srcMask={`${backendURL}/training/detour/${id}/golden`}
            prefPrefix="detour"
            fitDisk
            onSave={save}
            onDelete={remove}
            onCancel={() => window.close()}
          />
        </div>
      )}
    </AutoSizer>
  );
};

export default DetourEdit;
